<mat-toolbar class="main-toolbar">
  <mat-toolbar-row>
    <span class="logo-wrapper">
      <a routerLink="/dashboard">
        <img
          class="logo"
          src="../../../../../assets/AZ_logo.svg"
          alt="AstraZeneca logo"
        />
      </a>
    </span>

    <div class="toolbar-content" *ngIf="currentRoute != '/dashboard'">
      <nav class="nav-items">
        <a
          [routerLink]="'/scenario/prepare/' + scenairoId"
          routerLinkActive="active"
          class="nav-link"
          >Prepare</a
        >
        <a
          [routerLink]="'/scenario/decide/' + scenairoId"
          routerLinkActive="active"
          class="nav-link"
          >Decide</a
        >
        <a
          [routerLink]="'/help-and-support/' + scenarioIdSessionStorage"
          routerLinkActive="active"
          class="nav-link"
          >Help & Support</a
        >
        <button 
          *ngIf="shouldShowHowToPlayButton()"
          class="nav-button how-to-play-nav-btn"
          (click)="openHowToPlayGuide()"
        >
          How to Play?
        </button>
      </nav>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
